import React, { useEffect, useState } from 'react'
import { Select, SelectChangeEvent, MenuItem, FormControl, OutlinedInput, Box} from '@mui/material'
import { Regions } from 'src/constant/Region';
import ManageRegionAdTeam from './ManageRegionAdTeam';
import { useAdTeamStore } from 'src/stores/AdTeamStore';

//시,도 및 시/군/구를 고를 수 있는 Select박스 두 개
//사용상의 다양성 및 복잡성을 고려하여 여기서부터 복사해 커스텀 한 후, 사용할 것

const RegionSelectorAdTeam = () => {
    const setField = useAdTeamStore((state)=>state.setField)
    const team_area = useAdTeamStore((state)=>state.team_areas)
    
    const contents = Regions
    const menuProps = {
        PaperProps: {
            sx: {
              maxHeight: '200px',
              overflowY: 'auto',
            },
          },
          TransitionProps: {
            onEntering: (menuElement: HTMLElement) => {
              menuElement.scrollTop = 0;
            },
          },
    }
    const sx = {
            height:46,
            width:'160px'
    }
    const [wideloc,setWideLoc] = useState('')
    const [cityloc,setCityLoc] = useState('')
    const [locations,setLocations] = useState<any>(team_area)

    useEffect(()=>{
      setField('team_areas',locations)
    },[locations])

    const handleKeyChange = (e:SelectChangeEvent<string>)=>{
        setWideLoc(e.target.value)
        if(wideloc){
            setCityLoc('')
        }
    }
    const handleValueChange = (e: SelectChangeEvent<string>) => {
        const newCity_loc = e.target.value;
        setCityLoc(newCity_loc);
        
        let wideKey = wideloc; // 예: "서울특별시" → "서울"
        if (wideloc.endsWith('남도') || wideloc.endsWith('북도')) {
          wideKey =  wideloc[0] + wideloc[2]; // 예: 전라남도 → 전남 (0:'전', 2:'남')
        }
        else{
          wideKey = wideloc.slice(0, 2); // 예: 서울특별시 → 서울
        }
        
        // 현재 상태 복사
        const newLocations = { ...locations };
      
        if (newCity_loc === "전체") {
          newLocations[wideKey] = ["전체"];
        } else {
          const existing = newLocations[wideKey] ?? [];
      
          const updated = existing.filter((item: any) => item !== "전체");
      
          if (!updated.includes(newCity_loc)) {
            newLocations[wideKey] = [...updated, newCity_loc];
          } else {
            newLocations[wideKey] = updated;
          }
        }
        setLocations(newLocations);
      };

  return (
    <>
        <Box sx={{ display: "flex", gap: "15px"}}>
        <FormControl>
        <Select
            displayEmpty
            value={wideloc}
            onChange={handleKeyChange}
            renderValue={(selected) => selected as string || "시/도"}
            input={<OutlinedInput notched={false} name="시/도"/>}
            MenuProps={menuProps}
            sx={sx}
            >
            {Object.keys(contents).map((region)=>(
                <MenuItem key={region} value={region}>
                    {region}
                </MenuItem>
            ))}
        </Select>
        </FormControl>
        <FormControl >
        <Select
            value={cityloc}
            onChange={handleValueChange}
            renderValue={(selected) => selected || "시/군/구"}
            input={<OutlinedInput notched={false} name="시/군/구"/>}
            disabled={!wideloc}
            MenuProps={menuProps}
            displayEmpty
            sx={sx}>
            {(contents[wideloc] ?? []).map((district)=>(
                <MenuItem key={district} value={district}>
                    {district}
                </MenuItem>
            ))}
        </Select>
        </FormControl>
        </Box>
        <ManageRegionAdTeam user_area={locations} isModify={false} setLocations={setLocations}/>
        {/* {!isvalid &&
          <AlertSpan $isValid={false}>담당 지역을 1개 이상 설정해주세요</AlertSpan>
        } */}
    </>
  )
}

export default RegionSelectorAdTeam